export default __webpack_public_path__ + "static/media/internPurple.cd7213e4.svg";